import i18next from 'i18next'

import { ValidateFormService } from 'services/ValidateFormService'
import { ElockReasonModel } from 'sections/LKSection/modules/ELockModule/stores/Reason/ElockReasonModel'
import { OrderKeys } from 'sections/LKSection/modules/OrderModule/data'

import { MIN_DESCRIPTION_LENGTH } from './OrderELockForm'

export class ValidateElockForm extends ValidateFormService {
  validate = (uiStore: ElockReasonModel) => {
    const errors: string[] = []

    const getKey = (key: string) => `${OrderKeys.eLockModule}.validate.${key}`

    if (!uiStore.eLockReasonValue) {
      errors.push(i18next.t(getKey('invalidReason')))
    }

    if (!uiStore.description.trim().length) {
      errors.push(i18next.t(getKey('invalidDescription')))
    } else if (uiStore.description.trim().length < MIN_DESCRIPTION_LENGTH) {
      errors.push(i18next.t(getKey('invalidDescriptionLength'), { count: MIN_DESCRIPTION_LENGTH }))
    }

    return this.hasNotErrors(errors, i18next.t(getKey('заполнения формы')))
  }
}

export const validateElockForm = new ValidateElockForm()
